export const DEBUG_QUERY_PARAM_KEY = 'debug';
